// extracted by mini-css-extract-plugin
export default {"container":"ShortLinkOutput_container__s76M2"};